export default "__VITE_ASSET__Dp1WWb9a__"